// extracted by mini-css-extract-plugin
module.exports = {"container":"part-cases_container___R1tP"};